export default __webpack_public_path__ + "static/media/Bonus_Hisotry_Flexi_Savings_Plan.b7798744.pdf";